import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

type UseCompetitionGroupListQueryParams = Parameters<typeof SSF.api.groupsList>[0];

export const keys = createQueryKeySet<UseCompetitionGroupListQueryParams>('competitions.groups');

export function useCompetitionGroupListQuery(params?: UseCompetitionGroupListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.groupsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
